
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2f7a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2f7a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("giJtj", function(module, exports) {

$parcel$export(module.exports, "parseCodeBlock", function () { return $bde1998a668817e2$export$dcab8c768aa50ccc; });
$parcel$export(module.exports, "createBlockStash", function () { return $bde1998a668817e2$export$1138bc5bc2b1d7d3; });
// Rendering of fenced ``` blocks coming back from the model.
//
// Answers frequently use a fenced block to draw a "chain" — a sequence of
// nodes joined by arrows, often with a label written on the connector itself:
//
//     UE/application
//        |
//        | Subscription, URSP, requested S-NSSAI and DNN
//        v
//     5G Core
//
// Rendered as <pre> that becomes one very long line inside a horizontally
// scrollable box, which is close to unreadable. When a block looks like such a
// chain we render it as a proper flow diagram — nodes as numbered cards, the
// text carried on a connector as a label on the arrow between them — and
// everything else falls back to a plain (wrapping) code block.
// Fence info strings we drop instead of showing as the first step.
const $bde1998a668817e2$var$LANGUAGE_TOKENS = new Set([
    'text',
    'txt',
    'plain',
    'plaintext',
    'none',
    'raw',
    'output',
    'console',
    'mermaid',
    'flow',
    'flowchart',
    'ascii',
    'diagram',
    'bash',
    'sh',
    'shell',
    'zsh',
    'json',
    'yaml',
    'yml',
    'toml',
    'ini',
    'js',
    'javascript',
    'jsx',
    'ts',
    'typescript',
    'tsx',
    'python',
    'py',
    'java',
    'c',
    'cpp',
    'csharp',
    'go',
    'rust',
    'sql',
    'http',
    'xml',
    'html',
    'css',
    'md',
    'markdown',
    'diff',
    'log',
    'csv'
]);
// Models mix ASCII (| v -->) with Unicode arrows and box-drawing characters
// (│ ┃ ↓ ▼) in the same diagram, so every classification below accepts both.
const $bde1998a668817e2$var$VERTICAL_BARS = "|\uFF5C\xa6\u2502\u2503\u254E\u254F\u2506\u2507\u250A\u250B";
const $bde1998a668817e2$var$DOWN_ARROWS = "\u2193\u2B07\u21D3\u25BC\u25BD\u2304";
const $bde1998a668817e2$var$RIGHT_ARROW_SRC = "(?:[\u2192\u21D2\u2794\u279C\u279D\u279E\u279F\u27A1\u25B6]|-{1,2}>|={1,2}>)";
const $bde1998a668817e2$var$RIGHT_ARROW = new RegExp($bde1998a668817e2$var$RIGHT_ARROW_SRC);
// A line made of nothing but connector characters: "|", "│", "v", "-->", "...".
const $bde1998a668817e2$var$CONNECTOR_ONLY = new RegExp(`^(?:[${$bde1998a668817e2$var$VERTICAL_BARS}${$bde1998a668817e2$var$DOWN_ARROWS}vV]|-{1,2}>?|={1,2}>|[.\xb7]{2,}|${$bde1998a668817e2$var$RIGHT_ARROW_SRC})+$`);
// A connector carrying a label: "| Subscription, URSP and DNN", "--> via UPF".
// "v" is deliberately excluded — it would swallow words beginning with v.
const $bde1998a668817e2$var$LABELLED_CONNECTOR = new RegExp(`^(?:[${$bde1998a668817e2$var$VERTICAL_BARS}${$bde1998a668817e2$var$DOWN_ARROWS}]|${$bde1998a668817e2$var$RIGHT_ARROW_SRC})\\s+(\\S.*)$`);
const $bde1998a668817e2$var$LEADING_ARROW = new RegExp(`^(?:[${$bde1998a668817e2$var$DOWN_ARROWS}${$bde1998a668817e2$var$VERTICAL_BARS}]|${$bde1998a668817e2$var$RIGHT_ARROW_SRC})\\s*`);
const $bde1998a668817e2$var$TRAILING_ARROW = new RegExp(`\\s*(?:[${$bde1998a668817e2$var$DOWN_ARROWS}${$bde1998a668817e2$var$VERTICAL_BARS}]|${$bde1998a668817e2$var$RIGHT_ARROW_SRC})$`);
// A tree branch: "├── Slice policy", "│   └── Regional edge", "+-- Central DN".
// Group 1 is everything left of the branch character, so its length is the
// column the branch sits at — that is what gives the node its depth.
const $bde1998a668817e2$var$BRANCH_PREFIX = new RegExp(`^([ ]*(?:[${$bde1998a668817e2$var$VERTICAL_BARS}][ ]*)*)((?:[\u{251C}\u{2514}\u{2523}\u{2517}\u{2560}\u{255A}\u{255E}\u{2558}]|\\+|\\\\|\`|\\|)[-\u{2500}\u{2015}\u{2014}]+)[ ]*`);
const $bde1998a668817e2$var$MAX_STEPS = 14;
const $bde1998a668817e2$var$MAX_NODES = 24;
const $bde1998a668817e2$var$MAX_STEP_LENGTH = 180;
function $bde1998a668817e2$var$unescapeHtml(value) {
    return value.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
}
function $bde1998a668817e2$var$escapeHtml(value) {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
// Split a fence body into its info string ("text", "bash", …) and the code.
function $bde1998a668817e2$var$splitLanguage(body) {
    const lines = body.split('\n');
    const first = (lines[0] || '').trim();
    if (lines.length > 1 && $bde1998a668817e2$var$LANGUAGE_TOKENS.has(first.toLowerCase())) return {
        language: first.toLowerCase(),
        code: lines.slice(1).join('\n')
    };
    return {
        language: '',
        code: body
    };
}
function $bde1998a668817e2$var$isConnectorOnly(line) {
    return $bde1998a668817e2$var$CONNECTOR_ONLY.test(line.replace(/\s+/g, ''));
}
function $bde1998a668817e2$var$usableSteps(steps) {
    return steps.length >= 2 && steps.length <= $bde1998a668817e2$var$MAX_STEPS && steps.every((step)=>step.text.length > 0 && step.text.length <= $bde1998a668817e2$var$MAX_STEP_LENGTH && (step.label || '').length <= $bde1998a668817e2$var$MAX_STEP_LENGTH);
}
function $bde1998a668817e2$var$stripArrows(line) {
    return line.replace($bde1998a668817e2$var$LEADING_ARROW, '').replace($bde1998a668817e2$var$TRAILING_ARROW, '').trim();
}
// A label is often written across two connector lines ("PDU session request:"
// then "S-NSSAI + DNN"); joining those with a dash reads wrong after a colon.
function $bde1998a668817e2$var$joinLabels(labels) {
    return labels.reduce((acc, part)=>!acc ? part : acc + (/[:,(–—-]$/.test(acc) ? ' ' : " \u2014 ") + part, '');
}
function $bde1998a668817e2$export$d0336bdf4834574f(code) {
    const rawLines = code.split('\n').map((line)=>line.replace(/\t/g, '    '));
    const lines = rawLines.filter((line)=>line.trim());
    if (!lines.length) return null;
    // A chain written on a single line: "A → B → C".
    if (lines.length === 1) {
        const parts = lines[0].trim().split(new RegExp(`\\s*${$bde1998a668817e2$var$RIGHT_ARROW_SRC}\\s*`)).map((part)=>part.trim()).filter(Boolean);
        const steps = parts.map((text)=>({
                text: text,
                label: '',
                children: []
            }));
        return $bde1998a668817e2$var$usableSteps(steps) ? {
            direction: 'horizontal',
            steps: steps
        } : null;
    }
    // Multi-line: classify every line as a node, a connector, a labelled
    // connector or a tree branch, then nest the nodes by the column they sit at.
    const roots = [];
    const stack = [];
    let pendingLabels = [];
    let sawConnector = false;
    let sawBranch = false;
    let total = 0;
    let tooLong = false;
    for (const raw of lines){
        const line = raw.trim();
        if ($bde1998a668817e2$var$isConnectorOnly(line)) {
            sawConnector = true;
            continue;
        }
        // Branches are checked before labelled connectors: a nested branch line
        // starts with the parent's vertical rule ("│   └── x") and would otherwise
        // look like a connector carrying the label "└── x".
        const branch = raw.match($bde1998a668817e2$var$BRANCH_PREFIX);
        let depth;
        let text;
        if (branch) {
            sawBranch = true;
            // One column deeper than a plain node in the same column, so that
            // "├── a" directly under an unindented parent still nests inside it.
            depth = branch[1].length + 1;
            text = raw.slice(branch[0].length).trim();
        } else {
            const labelled = line.match($bde1998a668817e2$var$LABELLED_CONNECTOR);
            if (labelled) {
                sawConnector = true;
                pendingLabels.push(labelled[1].trim());
                continue;
            }
            depth = raw.length - raw.trimStart().length;
            text = $bde1998a668817e2$var$stripArrows(line);
        }
        if (!text) continue;
        if (text.length > $bde1998a668817e2$var$MAX_STEP_LENGTH) tooLong = true;
        while(stack.length && stack[stack.length - 1].depth >= depth)stack.pop();
        const parent = stack.length ? stack[stack.length - 1].node : null;
        // The first node can't have an incoming connector, so anything collected
        // before it is a stray prefix rather than an edge label.
        const label = !parent && !roots.length ? '' : $bde1998a668817e2$var$joinLabels(pendingLabels);
        if (label.length > $bde1998a668817e2$var$MAX_STEP_LENGTH) tooLong = true;
        const node = {
            text: text,
            label: label,
            children: []
        };
        (parent ? parent.children : roots).push(node);
        stack.push({
            depth: depth,
            node: node
        });
        pendingLabels = [];
        total++;
    }
    // Without a connector or a branch this is just a list of lines — leave it
    // as code.
    if (!sawConnector && !sawBranch) return null;
    if (tooLong || !roots.length || total < 2 || total > $bde1998a668817e2$var$MAX_NODES) return null;
    return {
        direction: 'vertical',
        steps: roots
    };
}
// Branch nodes are the parts of, or the alternatives under, the step that
// carries them. They stay unnumbered and arrowless: numbering them in the main
// column claimed a sequence the source never described.
function $bde1998a668817e2$var$renderBranch(children) {
    const items = children.map((child)=>`<li class="flow-branch-item">` + `<span class="flow-branch-text">${$bde1998a668817e2$var$escapeHtml(child.text)}</span>` + (child.label ? `<span class="flow-branch-note">${$bde1998a668817e2$var$escapeHtml(child.label)}</span>` : '') + (child.children.length ? $bde1998a668817e2$var$renderBranch(child.children) : '') + `</li>`).join('');
    return `<ul class="flow-branch">${items}</ul>`;
}
function $bde1998a668817e2$var$renderStep(step, index) {
    // "Label: detail" reads better with the label picked out.
    const match = step.text.match(/^([^:]{2,40}):\s+(.+)$/);
    const body = match ? `<span class="flow-step-label">${$bde1998a668817e2$var$escapeHtml(match[1].trim())}</span>` + `<span class="flow-step-detail">${$bde1998a668817e2$var$escapeHtml(match[2].trim())}</span>` : `<span class="flow-step-label">${$bde1998a668817e2$var$escapeHtml(step.text)}</span>`;
    return `<li class="flow-step">` + `<span class="flow-step-num" aria-hidden="true">${index + 1}</span>` + `<span class="flow-step-body">${body}` + (step.children.length ? $bde1998a668817e2$var$renderBranch(step.children) : '') + `</span>` + `</li>`;
}
function $bde1998a668817e2$var$renderLink(label) {
    // role="presentation" keeps the connector out of the list semantics while
    // leaving its label readable.
    return `<li class="flow-link${label ? '' : ' flow-link-bare'}" role="presentation">` + `<span class="flow-link-arrow" aria-hidden="true">\u{2193}</span>` + (label ? `<span class="flow-link-label">${$bde1998a668817e2$var$escapeHtml(label)}</span>` : '') + `</li>`;
}
function $bde1998a668817e2$var$renderFlow({ direction: direction, steps: steps }) {
    const items = steps.map((step, index)=>{
        // Horizontal chains never carry labels; their arrows are drawn in CSS.
        const link = direction === 'vertical' && index > 0 ? $bde1998a668817e2$var$renderLink(step.label) : '';
        return link + $bde1998a668817e2$var$renderStep(step, index);
    }).join('');
    return `<div class="flow-diagram flow-${direction}" role="group" aria-label="Process flow">` + `<ol class="flow-steps">${items}</ol>` + `</div>`;
}
function $bde1998a668817e2$export$dcab8c768aa50ccc(body) {
    const { language: language, code: code } = $bde1998a668817e2$var$splitLanguage(body.replace(/^\n+|\s+$/g, ''));
    return {
        language: language,
        code: code,
        flow: $bde1998a668817e2$export$d0336bdf4834574f(code)
    };
}
function $bde1998a668817e2$export$556694a3e5e940d6(body) {
    const { language: language, code: code, flow: flow } = $bde1998a668817e2$export$dcab8c768aa50ccc($bde1998a668817e2$var$unescapeHtml(body));
    if (flow) return $bde1998a668817e2$var$renderFlow(flow);
    const languageClass = language || 'text';
    return `<pre><code class="language-${languageClass}">${$bde1998a668817e2$var$escapeHtml(code)}</code></pre>`;
}
function $bde1998a668817e2$export$1138bc5bc2b1d7d3() {
    const blocks = [];
    return {
        /** Replace fenced blocks in `content` with inert tokens. */ stash (content) {
            const take = (match, body)=>{
                blocks.push($bde1998a668817e2$export$556694a3e5e940d6(body));
                return `\u{27E6}NSBLOCK${blocks.length - 1}\u{27E7}`;
            };
            return content.replace(/```([\s\S]*?)```/g, take).replace(/``([\s\S]*?)``/g, take);
        },
        /** Put the rendered blocks back, unwrapping any paragraph around them. */ restore (content) {
            if (!blocks.length) return content;
            let out = content.replace(/<p>\s*(?:<br\s*\/?>)*\s*(⟦NSBLOCK\d+⟧)\s*(?:<br\s*\/?>)*\s*<\/p>/g, '$1').replace(/(?:<br\s*\/?>)+\s*(⟦NSBLOCK\d+⟧)/g, '$1').replace(/(⟦NSBLOCK\d+⟧)\s*(?:<br\s*\/?>)+/g, '$1');
            blocks.forEach((html, index)=>{
                out = out.replace(`\u{27E6}NSBLOCK${index}\u{27E7}`, ()=>html);
            });
            return out;
        }
    };
}

});


var $giJtj = parcelRequire("giJtj");
function $5bde3d11ba71e4ca$export$7c68fd7983aa3ba2(text) {
    if (!text) return '';
    // Remove Grok/Perplexity meta tags before processing
    text = text.replace(/<grok:render[^>]*>[\s\S]*?<\/grok:render>/g, '');
    text = text.replace(/<argument[^>]*>[\s\S]*?<\/argument>/g, '');
    // Preserve network-slice-wiz web component before HTML escaping
    const webComponents = [];
    text = text.replace(/(<network-slice-wiz[^>]*>[\s\S]*?<\/network-slice-wiz>)/g, (match)=>{
        const placeholder = `__WEB_COMPONENT_${webComponents.length}__`;
        webComponents.push(match);
        return placeholder;
    });
    // Escape HTML first to prevent XSS
    let content = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    // Complete code blocks are rendered up front (arrow chains become flow
    // diagrams) and parked behind a token, so the rules below leave them alone.
    // Incomplete fences mid-stream simply don't match and stay as text.
    const blockStash = (0, $giJtj.createBlockStash)();
    content = blockStash.stash(content);
    // Detect if we have a table pattern (even incomplete)
    const hasTablePattern = /\|.*\|/.test(content);
    if (hasTablePattern) {
        // Try to format complete tables with separator lines
        const originalContent = content;
        content = content.replace(/^\s*(\|.+\|)\s*\n\s*(\|[-:\s|]+\|)\s*\n((?:\s*\|.+\|(?:\s*\n|$))+)/gm, function(match, headerLine, separatorLine, rows) {
            let html = '<table class="streaming-table"><thead><tr>';
            const header = headerLine.replace(/^\s*\||\|\s*$/g, '').trim();
            header.split('|').forEach((cell)=>{
                const trimmedCell = cell.trim();
                if (trimmedCell) html += `<th>${trimmedCell}</th>`;
            });
            html += '</tr></thead><tbody>';
            rows.trim().split('\n').forEach((row)=>{
                if (!row.trim() || !row.includes('|')) return;
                const cleanRow = row.replace(/^\s*\||\|\s*$/g, '').trim();
                if (!cleanRow) return;
                html += '<tr>';
                cleanRow.split('|').forEach((cell)=>{
                    const trimmedCell = cell.trim();
                    if (trimmedCell) html += `<td>${trimmedCell}</td>`;
                });
                html += '</tr>';
            });
            html += '</tbody></table>';
            return html + '\n'; // Preserve line break for subsequent content
        });
        // Group consecutive pipe-delimited rows into tables (without separator lines)
        content = content.replace(/((?:^\s*\|.+\|\s*$\n?)+)/gm, function(match) {
            // Skip if already processed as table
            if (match.includes('<table') || match.includes('<th>')) return match;
            const lines = match.trim().split('\n').filter((line)=>line.trim());
            if (lines.length < 2) return match; // Need at least 2 rows for a table
            // First row is header
            const headerCells = lines[0].replace(/^\s*\||\|\s*$/g, '').split('|').map((c)=>c.trim()).filter((c)=>c);
            let html = '<table class="streaming-table"><thead><tr>';
            headerCells.forEach((cell)=>{
                html += `<th>${cell}</th>`;
            });
            html += '</tr></thead><tbody>';
            // Rest are data rows
            for(let i = 1; i < lines.length; i++){
                const cells = lines[i].replace(/^\s*\||\|\s*$/g, '').split('|').map((c)=>c.trim()).filter((c)=>c);
                html += '<tr>';
                cells.forEach((cell)=>{
                    html += `<td>${cell}</td>`;
                });
                html += '</tr>';
            }
            html += '</tbody></table>\n';
            return html;
        });
        // Only wrap in streaming-content if no tables were successfully formatted
        // and the content still has unformatted table patterns
        if (content === originalContent && /\|.*\|.*\n.*\|.*\|/.test(content)) // Only wrap the table-like parts, not the entire content
        content = content.replace(/(\|[^|\n]*\|(?:\s*\n\s*\|[^|\n]*\|)*)/g, '<div class="streaming-content">$1</div>');
    }
    // Convert structured bullet lists to tables (e.g., API responses with key-value pairs)
    // Pattern: - **Key** – Description (with various separators: en-dash, em-dash, colon, hyphen)
    // Only applies to TOP-LEVEL bullets (no indentation) to avoid conflicts with nested lists
    content = content.replace(/(?:^- \*\*[^*]+\*\*\s*[–—:\-]\s*.+$(?:\n|$))+/gm, function(match, offset, fullString) {
        const lines = match.trim().split('\n').filter((line)=>line.trim());
        // Need at least 2 lines to make a table worthwhile
        if (lines.length < 2) return match;
        // Check if this block is followed by indented bullets (nested content)
        // If so, don't convert to table - it's a nested list structure
        const afterMatch = fullString.substring(offset + match.length);
        const nextLine = afterMatch.match(/^[ \t]*[^\n]*/);
        if (nextLine && /^  +[-*+]/.test(nextLine[0])) // Next line is an indented bullet - this is a nested list, not a table
        return match;
        // Check if all lines follow the pattern AND have substantial content after separator
        const validLines = lines.filter((line)=>{
            const match = line.match(/^- \*\*[^*]+\*\*\s*[–—:\-]\s*(.+)$/);
            if (!match) return false;
            // Require substantial content (not just whitespace or very short text)
            const content = match[1].trim();
            return content.length > 3;
        });
        if (validLines.length < 2) return match;
        let html = '<table class="streaming-table"><thead><tr><th>Item</th><th>Description</th></tr></thead><tbody>';
        validLines.forEach((line)=>{
            const itemMatch = line.match(/^- \*\*([^*]+)\*\*\s*[–—:\-]\s*(.+)$/);
            if (itemMatch) {
                const key = itemMatch[1].trim();
                const description = itemMatch[2].trim();
                html += `<tr><td><strong>${key}</strong></td><td>${description}</td></tr>`;
            }
        });
        html += '</tbody></table>\n';
        return html;
    });
    // Apply basic formatting that works well for streaming
    // Headers (allow optional leading whitespace for consistency with final formatter)
    content = content.replace(/^\s*###### (.*)$/gm, '<h6>$1</h6>');
    content = content.replace(/^\s*##### (.*)$/gm, '<h5>$1</h5>');
    content = content.replace(/^\s*#### (.*)$/gm, '<h4>$1</h4>');
    content = content.replace(/^\s*### (.*)$/gm, '<h3>$1</h3>');
    content = content.replace(/^\s*## (.*)$/gm, '<h2>$1</h2>');
    content = content.replace(/^\s*# (.*)$/gm, '<h1>$1</h1>');
    // Bold and italic (only complete patterns to avoid breaking mid-stream)
    content = content.replace(/\*\*([^*\n]{2,}?)\*\*/g, '<strong>$1</strong>');
    content = content.replace(/(?<!\*)\*([^*\n]{2,}?)\*(?!\*)/g, '<em>$1</em>');
    content = content.replace(/__([^_\n]{2,}?)__/g, '<strong>$1</strong>');
    content = content.replace(/(?<!_)_([^_\n]{2,}?)_(?!_)/g, '<em>$1</em>');
    // Inline code (only complete backticks)
    content = content.replace(/`([^`\n]+)`/g, '<code>$1</code>');
    // Lists - handle multi-level nested lists by preserving indentation
    // Mark bullets with their indentation level (0, 2, 4, 6 spaces, etc.)
    // Supports -, *, +, and • (Unicode bullet U+2022)
    content = content.replace(/^([ ]*)[\*\-\+•] (.+)$/gm, function(match, spaces, text) {
        const level = spaces.length / 2; // 0 spaces = level 0, 2 spaces = level 1, 4 = level 2, etc.
        // Trim trailing spaces to prevent unwanted <br> tags from markdown line breaks
        return `<li-ul-L${level}>${text.trim()}</li-ul-L${level}>`;
    });
    // Process from deepest nesting to shallowest to build proper hierarchy
    // Level 3 (6 spaces)
    content = content.replace(/((?:<li-ul-L3>.*?<\/li-ul-L3>\s*)+)/g, function(match) {
        return '<ul class="nested-list level-3">' + match.replace(/\s*<\/li-ul-L3>\s*<li-ul-L3>\s*/g, '</li><li>').replace(/<li-ul-L3>/g, '<li>').replace(/<\/li-ul-L3>/g, '</li>') + '</ul>';
    });
    // Move level-3 nested lists inside their parent level-2 items
    content = content.replace(/<\/li-ul-L2>\s*(<ul class="nested-list level-3">.*?<\/ul>)/gs, ' $1</li-ul-L2>');
    // Level 2 (4 spaces)
    content = content.replace(/((?:<li-ul-L2>(?:.*?(?:<ul class="nested-list level-3">.*?<\/ul>)?.*?)<\/li-ul-L2>\s*)+)/gs, function(match) {
        return '<ul class="nested-list level-2">' + match.replace(/\s*<\/li-ul-L2>\s*<li-ul-L2>\s*/g, '</li><li>').replace(/<li-ul-L2>/g, '<li>').replace(/<\/li-ul-L2>/g, '</li>') + '</ul>';
    });
    // Move level-2 nested lists inside their parent level-1 items
    content = content.replace(/<\/li-ul-L1>\s*(<ul class="nested-list level-2">.*?<\/ul>)/gs, ' $1</li-ul-L1>');
    // Level 1 (2 spaces)
    content = content.replace(/((?:<li-ul-L1>(?:.*?(?:<ul class="nested-list level-[23]">.*?<\/ul>)?.*?)<\/li-ul-L1>\s*)+)/gs, function(match) {
        return '<ul class="nested-list level-1">' + match.replace(/\s*<\/li-ul-L1>\s*<li-ul-L1>\s*/g, '</li><li>').replace(/<li-ul-L1>/g, '<li>').replace(/<\/li-ul-L1>/g, '</li>') + '</ul>';
    });
    // Move level-1 nested lists inside their parent level-0 items
    content = content.replace(/<\/li-ul-L0>\s*(<ul class="nested-list level-1">.*?<\/ul>)/gs, ' $1</li-ul-L0>');
    // Level 0 (top-level, no indentation)
    content = content.replace(/((?:<li-ul-L0>(?:.*?(?:<ul class="nested-list level-[123]">.*?<\/ul>)?.*?)<\/li-ul-L0>\s*)+)/gs, function(match) {
        return '<ul>' + match.replace(/\s*<\/li-ul-L0>\s*<li-ul-L0>\s*/g, '</li><li>').replace(/<li-ul-L0>/g, '<li>').replace(/<\/li-ul-L0>/g, '</li>') + '</ul>';
    });
    // Clean up any remaining tags
    for(let i = 0; i <= 3; i++){
        content = content.replace(new RegExp(`<li-ul-L${i}>`, 'g'), '<li>');
        content = content.replace(new RegExp(`</li-ul-L${i}>`, 'g'), '</li>');
    }
    // Clean up excessive whitespace around lists to prevent unwanted line breaks
    // Remove multiple newlines after closing nested lists
    content = content.replace(/(<\/ul>)\s*\n\s*\n+\s*/g, '$1\n');
    // Normalize whitespace between closing and opening list tags
    content = content.replace(/(<\/li>)\s*\n\s*\n+\s*(<li>)/g, '$1\n$2');
    // Remove extra whitespace after list closings before next content
    content = content.replace(/(<\/ul>)\s+(<li>)/g, '$1 $2');
    // Numbered lists
    content = content.replace(/^(\d+)\. (.+)$/gm, '<div class="numbered-point">$1. $2</div>');
    // Line breaks and paragraphs
    content = content.replace(/\n\n+/g, '</p><p>');
    content = content.replace(/\n/g, '<br>');
    // Wrap in paragraph if not already wrapped and doesn't start with a header.
    // The test has to stay anchored — an unanchored `<div` matched anywhere in
    // the chunk, which left the opening <p> off and produced a stray </p>.
    if (!content.match(/^\s*<(?:h[1-6]|div|p|table|ul|ol|pre)\b/)) content = '<p>' + content + '</p>';
    // Clean up empty paragraphs and unnecessary blank lines
    content = content.replace(/<p>\s*<\/p>/g, '');
    content = content.replace(/<p>(<br\s*\/?>)+\s*<\/p>/gi, '');
    content = content.replace(/<p>\s+<\/p>/g, '');
    // Remove empty paragraphs between structural elements
    content = content.replace(/(<\/h[1-6]>)\s*<p>\s*<\/p>\s*/gi, '$1');
    content = content.replace(/(<\/h[1-6]>)\s*<p>(<br\s*\/?>)+<\/p>\s*/gi, '$1');
    content = content.replace(/(<\/[uo]l>)\s*<p>\s*<\/p>\s*/gi, '$1');
    // Remove breaks immediately after headers and lists
    content = content.replace(/(<\/h[1-6]>)\s*(<br\s*\/?>)+/gi, '$1');
    content = content.replace(/(<\/[uo]l>)\s*(<br\s*\/?>)+/gi, '$1');
    // Remove multiple consecutive breaks
    content = content.replace(/(<br\s*\/?>){2,}/gi, '<br>');
    // Final cleanup: remove any remaining empty paragraphs
    content = content.replace(/<p>\s*<\/p>/g, '');
    // Convert escaped <br> tags back to actual line breaks
    // This allows legitimate line breaks in content (especially in tables) to render properly
    content = content.replace(/&lt;br&gt;/gi, '<br>');
    content = content.replace(/&lt;br\s*\/&gt;/gi, '<br>');
    // Restore rendered code blocks / flow diagrams
    content = blockStash.restore(content);
    // Restore network-slice-wiz web components
    webComponents.forEach((component, index)=>{
        content = content.replace(`__WEB_COMPONENT_${index}__`, component);
    });
    return content;
}


// Content-specific cleanup and transformations for NorthStar project
function $2304ccd93413a95d$export$bb05cafd456efa0b(content, citations = []) {
    // Wrap sections with headers specifically containing "for Engineers"
    // Only match headers where "for engineers" is at or near the end (not buried in middle)
    // Examples: "Guide for Engineers", "Technical Details for Network Engineers"
    // Captures the header and content until the next header
    content = content.replace(/(<h[1-6][^>]*>.*?for [Ee]ngineers?[:\s]{0,3}<\/h[1-6]>)((?:(?!<h[1-6]).)*)/gis, '<div class="engineer-info">$1$2</div>');
    // Remove PLMN prefixes/suffixes from headers since we only show S-NSSAI values
    // "S-NSSAI/PLMN" → "S-NSSAI"
    content = content.replace(/S-NSSAI\/PLMN/gi, 'S-NSSAI');
    // "PLMN-S-NSSAI" → "S-NSSAI"
    content = content.replace(/PLMN-S-NSSAI/gi, 'S-NSSAI');
    // Extract S-NSSAI from combined PLMN+S-NSSAI identifiers
    // Examples: "240 491-2018" → "1-2018", "999 0491-50" → "1-50"
    // PLMN = MCC (3 digits) + MNC (2-3 digits), S-NSSAI = SST (1 digit) + SD (2-4 digits)
    // Extract only S-NSSAI portion, as PLMN context is unnecessary in text references
    // Handle both labeled and unlabeled identifiers
    // "PLMN 240 491-2018" → "1-2018" or "PLMN 240491-2018" → "1-2018"
    // "240 491-50" → "1-50" or "240491-50" → "1-50" (supports 2-4 digit SD values)
    content = content.replace(/(?:PLMN )?(?:\d{3}\s?)(?:\d{2,3})(\d-\d{2,4})/gi, '$1');
    // Replace "S-NSSAI (PLMN XXX YY# prefix)" with "S-NSSAI defined for PLMN XXX YY#"
    // Handles both 2-digit and 3-digit MNC
    content = content.replace(/([Ss]-NSSAI) \(PLMN (\d{3}) (\d{2,3})\d prefix\)/g, '$1 defined for PLMN $2 $3');
    // Clean up local citations - remove all variants
    // Handles: [local: ...], [local-doc: ...], [local], [local-doc], [local context: ...]
    content = content.replace(/\[local(?:-doc)?(?::\s*[^\]]+)?\]/gi, '');
    content = content.replace(/\[local\s+context(?::\s*[^\]]+)?\]/gi, '');
    // Remove "(From local context)" and similar references
    content = content.replace(/\(From local context\)/gi, '');
    content = content.replace(/\[Local context\]/gi, '');
    // Remove document reference tags like [Previous: filename.pdf], [Next: ...], etc.
    content = content.replace(/\[(Previous|Next|See|Ref|Reference):\s*[^\]]+\]/gi, '');
    // Remove percentage sign from specific "1-1%" pattern only
    content = content.replace(/1-1%/g, '1-1');
    // Remove duplicate citation patterns with :search, :related, etc.
    // Example: [1:search] appears alongside [1], so we remove the :search variant
    content = content.replace(/\[(\d+):[a-z]+\]/gi, '');
    // Citations - format valid citation numbers as superscript links
    if (citations.length > 0) content = content.replace(/\[(\d+)\]/g, '<sup><a href="#citation-$1" class="citation-link">[$1]</a></sup>');
    return content;
}



var $giJtj = parcelRequire("giJtj");
function $e4ca669c5b241a34$export$d8a9fb65f810e211(responseData) {
    let content = responseData.content || 'No content available. Please check your API configuration.';
    console.log("\uD83D\uDCDD Formatting response, content length:", content.length);
    console.log("\uD83D\uDCDD Raw content preview:", content.substring(0, 500));
    console.log("\uD83D\uDCDD Raw content FULL:", content);
    // Log table-like content for debugging
    const tableRows = content.match(/\|.+\|/gm);
    if (tableRows) {
        console.log("\uD83D\uDCCA Found", tableRows.length, 'lines containing pipes in raw content');
        console.log("\uD83D\uDCCA First table row sample:", tableRows[0]);
        console.log("\uD83D\uDCCA All table rows:", tableRows);
    } else console.log("\u26A0\uFE0F No table rows found in raw content");
    // Remove Grok/Perplexity meta tags before processing
    content = content.replace(/<grok:render[^>]*>[\s\S]*?<\/grok:render>/g, '');
    content = content.replace(/<argument[^>]*>[\s\S]*?<\/argument>/g, '');
    // Preserve network-slice-wiz web component before HTML escaping
    const webComponents = [];
    content = content.replace(/(<network-slice-wiz[^>]*>[\s\S]*?<\/network-slice-wiz>)/g, (match)=>{
        const placeholder = `__WEB_COMPONENT_${webComponents.length}__`;
        webComponents.push(match);
        return placeholder;
    });
    // Escape HTML first to prevent XSS
    content = content.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    // Code blocks (triple and double backticks). Arrow chains become flow
    // diagrams, everything else a wrapping <pre>. The rendered HTML is parked
    // behind a token so none of the rules below can reach into it — they would
    // otherwise flatten its newlines and eat characters like "+" (codeBlocks.js).
    const blockStash = (0, $giJtj.createBlockStash)();
    content = blockStash.stash(content);
    // Tables - more robust regex to capture complete tables
    // First, handle traditional markdown tables with separator lines
    content = content.replace(/^\s*(\|.+\|)\s*\n\s*(\|[\s\-:|]+\|)\s*\n((?:\s*\|.+\|(?:\s*\n|$))*)/gm, function(match, headerLine, separatorLine, rowsSection) {
        console.log("\uD83D\uDCCA Found markdown table with separator");
        console.log("\uD83D\uDCCA Header line:", headerLine);
        console.log("\uD83D\uDCCA Row section:", rowsSection);
        // Extract header - remove leading/trailing pipes and trim
        const header = headerLine.replace(/^\s*\||\|\s*$/g, '').trim();
        let html = '<table class="api-table"><thead><tr>';
        header.split('|').forEach((cell)=>{
            const trimmedCell = cell.trim();
            if (trimmedCell) html += `<th>${trimmedCell}</th>`;
        });
        html += '</tr></thead><tbody>';
        // Process rows
        const rows = rowsSection.trim().split('\n');
        rows.forEach((row)=>{
            if (!row.trim() || !row.includes('|')) return;
            const cleanRow = row.replace(/^\s*\||\|\s*$/g, '').trim();
            if (!cleanRow) return;
            html += '<tr>';
            cleanRow.split('|').forEach((cell)=>{
                const trimmedCell = cell.trim();
                if (trimmedCell) html += `<td>${trimmedCell}</td>`;
            });
            html += '</tr>';
        });
        html += '</tbody></table>';
        console.log("\uD83D\uDCCA Generated table HTML:", html);
        console.log("\uD83D\uDCCA Table HTML length:", html.length);
        return html + '\n'; // Preserve line break for subsequent content
    });
    // Group consecutive pipe-delimited rows into tables (without separator lines)
    content = content.replace(/((?:^\s*\|.+\|\s*$\n?)+)/gm, function(match) {
        // Skip if already processed as table
        if (match.includes('<table') || match.includes('<th>')) return match;
        const lines = match.trim().split('\n').filter((line)=>line.trim());
        if (lines.length < 2) return match; // Need at least 2 rows for a table
        console.log("\uD83D\uDCCA Grouping", lines.length, 'consecutive rows into table');
        // First row is header
        const headerCells = lines[0].replace(/^\s*\||\|\s*$/g, '').split('|').map((c)=>c.trim()).filter((c)=>c);
        let html = '<table class="api-table"><thead><tr>';
        headerCells.forEach((cell)=>{
            html += `<th>${cell}</th>`;
        });
        html += '</tr></thead><tbody>';
        // Rest are data rows
        for(let i = 1; i < lines.length; i++){
            const cells = lines[i].replace(/^\s*\||\|\s*$/g, '').split('|').map((c)=>c.trim()).filter((c)=>c);
            html += '<tr>';
            cells.forEach((cell)=>{
                html += `<td>${cell}</td>`;
            });
            html += '</tr>';
        }
        html += '</tbody></table>\n';
        return html;
    });
    // Check if tables were successfully converted
    const tableCount = (content.match(/<table/g) || []).length;
    console.log("\uD83D\uDCCA After table processing, found", tableCount, 'table tags in content');
    if (tableCount > 0) {
        const tablePreview = content.match(/<table[\s\S]{0,200}/);
        console.log("\uD83D\uDCCA Table preview:", tablePreview ? tablePreview[0] : 'Not found');
    }
    // Convert structured bullet lists to tables (e.g., API responses with key-value pairs)
    // Pattern: - **Key** – Description (with various separators: en-dash, em-dash, colon, hyphen)
    // Only applies to TOP-LEVEL bullets (no indentation) to avoid conflicts with nested lists
    content = content.replace(/(?:^- \*\*[^*]+\*\*\s*[–—:\-]\s*.+$(?:\n|$))+/gm, function(match, offset, fullString) {
        const lines = match.trim().split('\n').filter((line)=>line.trim());
        // Need at least 2 lines to make a table worthwhile
        if (lines.length < 2) return match;
        // Check if this block is followed by indented bullets (nested content)
        // If so, don't convert to table - it's a nested list structure
        const afterMatch = fullString.substring(offset + match.length);
        const nextLine = afterMatch.match(/^[ \t]*[^\n]*/);
        if (nextLine && /^  +[-*+]/.test(nextLine[0])) // Next line is an indented bullet - this is a nested list, not a table
        return match;
        console.log("\uD83D\uDCCA Converting structured bullet list to table, found", lines.length, 'items');
        // Check if all lines follow the pattern AND have substantial content after separator
        const validLines = lines.filter((line)=>{
            const match = line.match(/^- \*\*[^*]+\*\*\s*[–—:\-]\s*(.+)$/);
            if (!match) return false;
            // Require substantial content (not just whitespace or very short text)
            const content = match[1].trim();
            return content.length > 3;
        });
        if (validLines.length < 2) return match;
        let html = '<table class="api-table"><thead><tr><th>Item</th><th>Description</th></tr></thead><tbody>';
        validLines.forEach((line)=>{
            const itemMatch = line.match(/^- \*\*([^*]+)\*\*\s*[–—:\-]\s*(.+)$/);
            if (itemMatch) {
                const key = itemMatch[1].trim();
                const description = itemMatch[2].trim();
                html += `<tr><td><strong>${key}</strong></td><td>${description}</td></tr>`;
            }
        });
        html += '</tbody></table>\n';
        console.log("\uD83D\uDCCA Generated table from bullet list, HTML length:", html.length);
        return html;
    });
    // Inline code
    content = content.replace(/`([^`]+)`/g, '<code>$1</code>');
    // Headers (allow optional leading whitespace)
    const beforeHeaders = content;
    content = content.replace(/^\s*###### (.*)$/gm, '<h6>$1</h6>');
    content = content.replace(/^\s*##### (.*)$/gm, '<h5>$1</h5>');
    content = content.replace(/^\s*#### (.*)$/gm, '<h4>$1</h4>');
    content = content.replace(/^\s*### (.*)$/gm, '<h3>$1</h3>');
    content = content.replace(/^\s*## (.*)$/gm, '<h2>$1</h2>');
    content = content.replace(/^\s*# (.*)$/gm, '<h1>$1</h1>');
    if (beforeHeaders !== content) console.log("\u2705 Header conversion applied. Sample:", content.substring(0, 500));
    else console.log("\u26A0\uFE0F  No headers found to convert");
    // Bold and italic
    content = content.replace(/\*\*\*(.+?)\*\*\*/g, '<strong><em>$1</em></strong>');
    content = content.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    content = content.replace(/\*(.+?)\*/g, '<strong>$1</strong>');
    content = content.replace(/\*([^*]+)\*/g, '<em>$1</em>');
    content = content.replace(/___(.+?)___/g, '<strong><em>$1</em></strong>');
    content = content.replace(/__(.+?)__/g, '<strong>$1</strong>');
    content = content.replace(/_(.+?)_/g, '<em>$1</em>');
    // Links
    content = content.replace(/\[([^\]]+)\]\(([^)]+)\)/g, function(match, text, url) {
        const unescapedUrl = url.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
        return `<a href="${unescapedUrl}" target="_blank" rel="noopener noreferrer">${text}</a>`;
    });
    // Ordered lists (handle optional leading whitespace)
    content = content.replace(/^\s*(\d+)\. (.+)$/gm, '<li-ol>$2</li-ol>');
    content = content.replace(/(<li-ol>[^<]*<\/li-ol>(?:\s*<li-ol>[^<]*<\/li-ol>)*)/gs, function(match) {
        // Remove all whitespace between list items for clean formatting
        return '<ol>' + match.replace(/\s+/g, ' ').replace(/\s*<\/li-ol>\s*<li-ol>\s*/g, '</li><li>').replace(/<li-ol>/g, '<li>').replace(/<\/li-ol>/g, '</li>') + '</ol>';
    });
    // Clean up any remaining li-ol tags
    content = content.replace(/<li-ol>/g, '<li>').replace(/<\/li-ol>/g, '</li>');
    // Block bullets - handle multi-level nested lists by preserving indentation
    // Mark bullets with their indentation level (0, 2, 4, 6 spaces, etc.)
    // Supports -, *, +, and • (Unicode bullet U+2022)
    content = content.replace(/^([ ]*)[\*\-\+•] (.+)$/gm, function(match, spaces, text) {
        const level = spaces.length / 2; // 0 spaces = level 0, 2 spaces = level 1, 4 = level 2, etc.
        // Trim trailing spaces to prevent unwanted <br> tags from markdown line breaks
        return `<li-ul-L${level}>${text.trim()}</li-ul-L${level}>`;
    });
    // Process from deepest nesting to shallowest to build proper hierarchy
    // Level 3 (6 spaces)
    content = content.replace(/((?:<li-ul-L3>.*?<\/li-ul-L3>\s*)+)/g, function(match) {
        return '<ul class="nested-list level-3">' + match.replace(/\s*<\/li-ul-L3>\s*<li-ul-L3>\s*/g, '</li><li>').replace(/<li-ul-L3>/g, '<li>').replace(/<\/li-ul-L3>/g, '</li>') + '</ul>';
    });
    // Move level-3 nested lists inside their parent level-2 items
    content = content.replace(/<\/li-ul-L2>\s*(<ul class="nested-list level-3">.*?<\/ul>)/gs, ' $1</li-ul-L2>');
    // Level 2 (4 spaces)
    content = content.replace(/((?:<li-ul-L2>(?:.*?(?:<ul class="nested-list level-3">.*?<\/ul>)?.*?)<\/li-ul-L2>\s*)+)/gs, function(match) {
        return '<ul class="nested-list level-2">' + match.replace(/\s*<\/li-ul-L2>\s*<li-ul-L2>\s*/g, '</li><li>').replace(/<li-ul-L2>/g, '<li>').replace(/<\/li-ul-L2>/g, '</li>') + '</ul>';
    });
    // Move level-2 nested lists inside their parent level-1 items
    content = content.replace(/<\/li-ul-L1>\s*(<ul class="nested-list level-2">.*?<\/ul>)/gs, ' $1</li-ul-L1>');
    // Level 1 (2 spaces)
    content = content.replace(/((?:<li-ul-L1>(?:.*?(?:<ul class="nested-list level-[23]">.*?<\/ul>)?.*?)<\/li-ul-L1>\s*)+)/gs, function(match) {
        return '<ul class="nested-list level-1">' + match.replace(/\s*<\/li-ul-L1>\s*<li-ul-L1>\s*/g, '</li><li>').replace(/<li-ul-L1>/g, '<li>').replace(/<\/li-ul-L1>/g, '</li>') + '</ul>';
    });
    // Move level-1 nested lists inside their parent level-0 items
    content = content.replace(/<\/li-ul-L0>\s*(<ul class="nested-list level-1">.*?<\/ul>)/gs, ' $1</li-ul-L0>');
    // Level 0 (top-level, no indentation)
    content = content.replace(/((?:<li-ul-L0>(?:.*?(?:<ul class="nested-list level-[123]">.*?<\/ul>)?.*?)<\/li-ul-L0>\s*)+)/gs, function(match) {
        return '<ul>' + match.replace(/\s*<\/li-ul-L0>\s*<li-ul-L0>\s*/g, '</li><li>').replace(/<li-ul-L0>/g, '<li>').replace(/<\/li-ul-L0>/g, '</li>') + '</ul>';
    });
    // Clean up any remaining tags
    for(let i = 0; i <= 3; i++){
        content = content.replace(new RegExp(`<li-ul-L${i}>`, 'g'), '<li>');
        content = content.replace(new RegExp(`</li-ul-L${i}>`, 'g'), '</li>');
    }
    // Clean up excessive whitespace around lists to prevent unwanted line breaks
    // Remove multiple newlines after closing nested lists
    content = content.replace(/(<\/ul>)\s*\n\s*\n+\s*/g, '$1\n');
    // Normalize whitespace between closing and opening list tags
    content = content.replace(/(<\/li>)\s*\n\s*\n+\s*(<li>)/g, '$1\n$2');
    // Remove extra whitespace after list closings before next content
    content = content.replace(/(<\/ul>)\s+(<li>)/g, '$1 $2');
    // Inline bullets
    content = content.replace(/([^\n])[\*\-\+] ([^*\n]+)/g, function(match, prefix, item) {
        return prefix + '<span class="inline-bullet">\u2022 ' + item.trim() + '</span><br>';
    });
    // Apply content-specific cleanup and transformations
    const citations = responseData.citations || [];
    content = (0, $2304ccd93413a95d$export$bb05cafd456efa0b)(content, citations);
    // Paragraphs - normalize newlines to avoid superfluous blank lines
    // First, replace triple+ newlines with double newlines
    content = content.replace(/\n{3,}/g, '\n\n');
    // Convert double newlines to paragraph breaks
    content = content.replace(/\n\n/g, '</p><p>');
    // Convert remaining single newlines to spaces (joining text within paragraphs)
    content = content.replace(/\n/g, ' ');
    // Clean up stray bullet characters - comprehensive removal
    // Handle multiple Unicode bullet variants: •, ·, ∙, ⋅, ◦, ▪, ▫, ‣, ⁃, ◘, ◙, and more
    // Pattern 1: Bullets with spaces around them
    content = content.replace(/\s+[•·∙⋅◦▪▫‣⁃◘◙∗⁎]\s+/g, ' ');
    // Pattern 2: Bullets attached to words
    content = content.replace(/([^\s>])[•·∙⋅◦▪▫‣⁃◘◙∗⁎]\s*/g, '$1 ');
    // Pattern 3: Any remaining standalone bullets (catch-all)
    content = content.replace(/[•·∙⋅◦▪▫‣⁃◘◙∗⁎]/g, ' ');
    // Clean up multiple spaces
    content = content.replace(/\s{2,}/g, ' ');
    // Wrap in paragraph tags
    content = '<p>' + content + '</p>';
    // Cleanup - remove empty paragraphs and fix nesting
    content = content.replace(/<p>\s*<\/p>/g, '');
    content = content.replace(/<p>(<[uo]l>)/g, '$1');
    content = content.replace(/(<\/[uo]l>)<\/p>/g, '$1');
    content = content.replace(/<p>(<table)/g, '$1');
    content = content.replace(/(<\/table>)<\/p>/g, '$1');
    content = content.replace(/<p>(<h[1-6]>)/g, '$1');
    content = content.replace(/(<\/h[1-6]>)<\/p>/g, '$1');
    // Remove paragraphs that only contain whitespace or breaks
    content = content.replace(/<p>\s*<\/p>/g, '');
    content = content.replace(/<p>(<br\s*\/?>)+\s*<\/p>/gi, '');
    content = content.replace(/<p>\s+<\/p>/g, '');
    // Remove empty paragraphs between structural elements
    content = content.replace(/(<\/h[1-6]>)\s*<p>\s*<\/p>\s*/gi, '$1');
    content = content.replace(/(<\/h[1-6]>)\s*<p>(<br\s*\/?>)+<\/p>\s*/gi, '$1');
    content = content.replace(/(<\/[uo]l>)\s*<p>\s*<\/p>\s*/gi, '$1');
    // Remove breaks immediately after list endings
    content = content.replace(/(<\/[uo]l>)\s*(<br\s*\/?>)+/gi, '$1');
    // Remove breaks immediately after headers
    content = content.replace(/(<\/h[1-6]>)\s*(<br\s*\/?>)+/gi, '$1');
    // Remove multiple consecutive breaks
    content = content.replace(/(<br\s*\/?>){2,}/gi, '<br>');
    // Final cleanup: remove any remaining empty paragraphs
    content = content.replace(/<p>\s*<\/p>/g, '');
    // Convert escaped <br> tags back to actual line breaks
    // This allows legitimate line breaks in content (especially in tables) to render properly
    content = content.replace(/&lt;br&gt;/gi, '<br>');
    content = content.replace(/&lt;br\s*\/&gt;/gi, '<br>');
    // Restore rendered code blocks / flow diagrams
    content = blockStash.restore(content);
    // Restore network-slice-wiz web components
    webComponents.forEach((component, index)=>{
        content = content.replace(`__WEB_COMPONENT_${index}__`, component);
    });
    const relatedQuestions = responseData.related_questions || [];
    return {
        content: content,
        relatedQuestions: relatedQuestions,
        citations: citations
    };
}


// Expands NorthStar shorthand and 5G acronyms before a query reaches the API,
// so the model is not left guessing what "RRP" or "5QI" means.
//
// Shared with scripts/build-precomputed-answers.mjs: a precomputed answer is
// keyed by the expanded query, so both sides must expand identically or every
// lookup misses and falls back to a live call.
function $29fac8d1b7d15aee$export$23ac54a073d6d184(query) {
    let expanded = query;
    // Replace terms
    expanded = expanded.replace(/\bnorthstar\b/gi, 'NorthStar 5G Innovation Network');
    expanded = expanded.replace(/\bverticals\b/gi, 'verticals including healthcare');
    expanded = expanded.replace(/\RRP\b/gi, 'Radio Resource Partitioning');
    expanded = expanded.replace(/\bNorthStar partners\b/gi, 'organizations who have joined the NorthStar 5G Innovation Network');
    // Replace 5G acronyms with full expansions
    expanded = expanded.replace(/\b5QI\b/g, '5QI (5G QoS Identifier)');
    expanded = expanded.replace(/\bAMF\b/g, 'AMF (Access and Mobility Management Function)');
    expanded = expanded.replace(/\bDNN\b/g, 'DNN (Data Network Name)');
    expanded = expanded.replace(/\bEBO\b/g, 'EBO (Edge Break-Out)');
    expanded = expanded.replace(/\bENL\b/g, 'ENL (Ericsson Network Location)');
    expanded = expanded.replace(/\bgNB\b/g, 'gNB (Next-generation Node B, 5G base station)');
    expanded = expanded.replace(/\bKPI\b/g, 'KPI (Key Performance Indicator)');
    expanded = expanded.replace(/\bL4S\b/g, 'L4S (Low Latency Low Loss Scalable throughput)');
    expanded = expanded.replace(/\bLPG\b/g, 'LPG (Local Packet Gateway)');
    expanded = expanded.replace(/\bMNO\b/g, 'MNO (Mobile Network Operator)');
    expanded = expanded.replace(/\bQoE\b/g, 'QoE (Quality of Experience)');
    expanded = expanded.replace(/\bQoS\b/g, 'QoS (Quality of Service)');
    expanded = expanded.replace(/\bRAN\b/g, 'RAN (Radio Access Network)');
    expanded = expanded.replace(/\bRSRP\b/g, 'RSRP (Reference Signal Received Power)');
    expanded = expanded.replace(/\bRSRQ\b/g, 'RSRQ (Reference Signal Received Quality)');
    expanded = expanded.replace(/\bRTT\b/g, 'RTT (Round-Trip Time)');
    expanded = expanded.replace(/\bSINR\b/g, 'SINR (Signal-to-Interference-plus-Noise Ratio)');
    expanded = expanded.replace(/\bSMF\b/g, 'SMF (Session Management Function)');
    expanded = expanded.replace(/\bS-NSSAI\b/g, 'S-NSSAI (Single Network Slice Selection Assistance Information)');
    expanded = expanded.replace(/\bUDM\b/g, 'UDM (Unified Data Management)');
    expanded = expanded.replace(/\bUE\b/g, 'UE (User Equipment)');
    expanded = expanded.replace(/\bUPF\b/g, 'UPF (User Plane Function)');
    expanded = expanded.replace(/\bDL\b/g, 'DL (Downlink)');
    expanded = expanded.replace(/\bUL\b/g, 'UL (Uplink)');
    expanded = expanded.replace(/\bNR\b/g, 'NR (New Radio, 5G radio access)');
    return expanded;
}


// The Agent API has no `return_related_questions`, so the function asks the
// model to end with a "Related questions:" section and we split it back out.
// Keep in sync with RELATED_QUESTIONS_INSTRUCTION in perplexity-api.mjs.
//
// Shared with scripts/build-precomputed-answers.mjs so a precomputed answer is
// stored in the same shape a live one arrives in.
function $2d5ee9d6a3adacc4$export$28f17cdf29713751(text) {
    const match = text.match(/\n\s*(?:#{1,6}\s*)?\**Related questions:?\**\s*\n([\s\S]*)$/i);
    if (!match) return {
        content: text,
        relatedQuestions: []
    };
    const relatedQuestions = match[1].split('\n').map((line)=>line.replace(/^\s*(?:[-*+•]|\d+[.)])\s*/, '').trim()).filter((line)=>line.length > 0).slice(0, 5);
    return {
        content: text.slice(0, match.index).trimEnd(),
        relatedQuestions: relatedQuestions
    };
}


// The clickable questions under "Find out more about NorthStar".
//
// EDIT THIS LIST to add, remove or reword a question - it is the single source
// of truth. The page renders these rows at load, and the build precomputes an
// answer for each one so a click is instant.
//
// Two things follow from that:
//
//  - A new question has no precomputed answer until the next deploy. Until
//    then it still works, it just goes to the live API and takes ~28s.
//  - Rewording a question invalidates its cached answer, because the cache is
//    keyed on the question text. The old entry is simply never looked up
//    again, and the new wording is precomputed on the next build.
//
// Keep them short and specific: the answer quality depends on the question,
// and vague questions produce long, slow, unfocused answers.
const $9e5191f6d1518599$export$b15addf50b1af20d = [
    'What is the purpose of the NorthStar 5G innovation environment?',
    'What are the functions provided by the NorthStar 5G innovation environment?',
    'What verticals can benefit from NorthStar and 5G SA?',
    'What are some real-world use cases enabled by NorthStar?',
    'What is a network slice?',
    'How does network slicing work in practice together with RRPs, DNNs and 5QIs?',
    'What network slices does NorthStar use?',
    'What 5QIs are there in the standard?',
    'Are separate network slices needed for separating traffic flows or can DNNs be used instead?',
    'How can companies join or collaborate with NorthStar?'
];


document.addEventListener('DOMContentLoaded', ()=>{
    const searchButton = document.getElementById('search-button');
    const searchInput = document.getElementById('search-input');
    const resultContainer = document.getElementById('result');
    const errorContainer = document.getElementById('error');
    const imageContainer = document.getElementById('image-container');
    let abortController = null;
    let summaryAbortController = null;
    let history = []; // keep conversation turns here
    function scrollInputIntoView() {
        const input = document.getElementById('search-input');
        if (input) {
            input.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            input.focus();
        }
    }
    function clearError() {
        errorContainer.textContent = '';
    }
    function displayError(message) {
        errorContainer.textContent = `Error: ${message}`;
        resultContainer.innerHTML = '';
    }
    function showLoading() {
        resultContainer.innerHTML = '<div class="loading-animation">Loading...</div>';
    }
    function hideLoading() {
        const loading = resultContainer.querySelector('.loading-animation');
        if (loading) loading.remove();
    }
    // Circular countdown timer functions
    let countdownInterval;
    const FULL_DASH_ARRAY = 283;
    function showLoadingTime(timeLimit = 10) {
        const timer = document.getElementById('circular-countdown');
        if (!timer) {
            console.warn('Timer element not found, skipping');
            return;
        }
        timer.style.display = 'block';
        let timePassed = 0;
        let timeLeft = timeLimit;
        const label = document.getElementById('base-timer-label');
        if (label) label.textContent = timeLeft;
        setCircleDasharray(timeLeft, timeLimit);
        countdownInterval = setInterval(()=>{
            timePassed += 1;
            timeLeft = timeLimit - timePassed;
            if (label) label.textContent = timeLeft > 0 ? timeLeft : "\u2026";
            setCircleDasharray(timeLeft, timeLimit);
            if (timeLeft <= 0) clearInterval(countdownInterval);
        }, 1000);
    }
    function hideLoadingTime() {
        const timer = document.getElementById('circular-countdown');
        if (timer) timer.style.display = 'none';
        if (countdownInterval) clearInterval(countdownInterval);
    }
    function setCircleDasharray(timeLeft, timeLimit) {
        const path = document.getElementById('base-timer-path-remaining');
        if (path) {
            const circleDasharray = `${(timeLeft / timeLimit * FULL_DASH_ARRAY).toFixed(0)} 283`;
            path.setAttribute('stroke-dasharray', circleDasharray);
        }
    }
    // Answers for the predefined questions are generated at build time by
    // scripts/build-precomputed-answers.mjs, because a live answer costs ~28s of
    // which ~22s is the model writing - and those questions are known in advance.
    // Fetched once on load so a click is instant. Any failure (no cache file, bad
    // JSON, offline) resolves to null and every question goes to the live API.
    let precomputedPromise = null;
    function loadPrecomputedAnswers() {
        if (!precomputedPromise) precomputedPromise = fetch('/precomputed-answers.json').then((response)=>response.ok ? response.json() : null).then((data)=>{
            if (data) console.log("\uD83D\uDCE6 Precomputed answers loaded:", Object.keys(data.answers || {}).length, '| generated', data.generated_at, '| config', JSON.stringify(data.config));
            else // Either PPLX_PRECOMPUTE is off or the build could not generate.
            console.log("\uD83D\uDCE6 No precomputed answers - every question goes to the live API");
            return data;
        }).catch(()=>null);
        return precomputedPromise;
    }
    async function getPrecomputedAnswer(query) {
        const data = await loadPrecomputedAnswers();
        return data?.answers?.[query] || null;
    }
    // Warm the cache as soon as the page opens.
    loadPrecomputedAnswers();
    // And warm the function itself, so a first free-text question does not pay
    // the cold start plus corpus parse. Worth well under a second, and only for
    // free-text: the predefined questions are served from the cache above and
    // never reach the function. Fire-and-forget - a failure changes nothing.
    fetch('/.netlify/functions/perplexity-api', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            warm: true
        })
    }).catch(()=>{});
    // Render the clickable questions from src/data/predefined-questions.js - the
    // single source of truth the build also precomputes answers from. Clicks are
    // picked up by the delegated listener further down, so rows added here need
    // no wiring of their own.
    const predefinedTable = document.getElementById('predefined-questions');
    if (predefinedTable) predefinedTable.innerHTML = (0, $9e5191f6d1518599$export$b15addf50b1af20d).map((question)=>`<tr><td><a href="#" class="predefined-question">${escapeHtml(question)}</a></td></tr>`).join('');
    // Pull the answer text out of an Agent API `output[]` array.
    function textFromOutput(output) {
        return output.filter((item)=>item?.type === 'message').flatMap((item)=>item.content || []).filter((part)=>part?.type === 'output_text').map((part)=>part.text).join('');
    }
    // Perplexity Agent API call with streaming support
    async function callPerplexityAPI(query, signal, onChunk = null) {
        try {
            console.log("\uD83D\uDD35 Calling API with query:", query);
            const response = await fetch('/.netlify/functions/perplexity-api', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    query: query,
                    history: history,
                    relatedQuestions: true
                }),
                signal: signal
            });
            console.log("\uD83D\uDFE2 Response status:", response.status);
            console.log("\uD83D\uDFE2 Response body:", response.body);
            if (!response.ok) {
                const errorText = await response.text();
                console.error("\uD83D\uDD34 Error response:", errorText);
                throw new Error(`HTTP error ${response.status}: ${errorText}`);
            }
            // Streaming SSE response: the Agent API emits typed events, one JSON
            // object per `data:` line. There is no [DONE] sentinel — the stream ends
            // with exactly one terminal event.
            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let fullContent = '';
            let buffer = '';
            let citations = [];
            let streamError = null;
            let sawTerminal = false;
            let matchedSSE = false;
            let rawBody = '';
            let hitTokenCap = false;
            // Diagnostics: when each kind of event first arrived, and how long the
            // first answer token took. A run killed by the 30s function limit shows
            // only lifecycle events and never reaches response.output_text.delta;
            // the timings show which leg consumed the budget.
            const eventFirstSeen = new Map();
            const startedAt = Date.now();
            let firstDeltaMs = null;
            // A preset bundles a model rather than naming one, and may resolve to a
            // third-party model. The terminal event echoes whichever model actually
            // served the run, which is the only way to see what a preset resolves to.
            let servedModel = null;
            // Citations now live in the `search_results` output item, not at the
            // top level. Multi-step runs can emit more than one, so dedupe by URL.
            const collectSources = (item)=>{
                if (item?.type !== 'search_results') return;
                for (const result of item.results || [])if (result?.url && !citations.includes(result.url)) citations.push(result.url);
            };
            const handleEvent = (event)=>{
                // Error frame emitted by our own function when the upstream read fails.
                if (!event.type && event.error) {
                    streamError = event.message || event.error;
                    sawTerminal = true;
                    return;
                }
                if (event.type && !eventFirstSeen.has(event.type)) eventFirstSeen.set(event.type, Date.now() - startedAt);
                switch(event.type){
                    case 'response.output_text.delta':
                        if (event.delta) {
                            if (firstDeltaMs === null) firstDeltaMs = Date.now() - startedAt;
                            fullContent += event.delta;
                            if (onChunk) onChunk((0, $2d5ee9d6a3adacc4$export$28f17cdf29713751)(fullContent).content);
                        }
                        break;
                    case 'response.output_item.done':
                        collectSources(event.item);
                        break;
                    // Terminal events - exactly one of these arrives.
                    case 'response.completed':
                    case 'response.incomplete':
                        {
                            sawTerminal = true;
                            if (event.response?.model) servedModel = event.response.model;
                            const output = event.response?.output || [];
                            output.forEach(collectSources);
                            if (!fullContent) fullContent = textFromOutput(output);
                            if (event.response?.incomplete_details?.reason === 'max_output_tokens') {
                                console.warn("\u26A0\uFE0F Answer truncated: max_output_tokens reached");
                                hitTokenCap = true;
                            }
                            break;
                        }
                    case 'response.failed':
                    case 'response.cancelled':
                        {
                            sawTerminal = true;
                            // A failure with no message (e.g. an account-level rejection) is
                            // otherwise undiagnosable, so log the whole event and surface any
                            // code/type it carries rather than a bare "Run failed".
                            const { instructions: instructions, tools: tools, ...failed } = event.response || {};
                            console.error(`\u{1F534} ${event.type} event:`, {
                                ...event,
                                response: failed
                            });
                            const err = event.response?.error || event.error || {};
                            const detail = err.message || err.code || err.type;
                            streamError = detail ? `Run ${event.type.slice(9)}: ${detail}` : `Run ${event.type.slice(9)} (no reason given by Perplexity)`;
                            break;
                        }
                    case 'error':
                        sawTerminal = true;
                        streamError = event.error?.message || event.message || 'Stream error';
                        break;
                    default:
                        break;
                }
            };
            // Accept `data:` with or without the conventional space after the colon.
            const handleLine = (line)=>{
                if (!line.startsWith('data:')) return;
                const data = line.slice(5).trim();
                if (!data) return;
                matchedSSE = true;
                try {
                    handleEvent(JSON.parse(data));
                } catch (e) {
                    // Skip malformed JSON - this is normal for streaming responses
                    console.log('Skipping malformed JSON line (normal for streaming)');
                }
            };
            // A non-streamed run comes back as a single JSON Response object rather
            // than an event stream. Recover the answer from it instead of showing the
            // user an empty result. Returns false if the body is not that shape.
            const recoverFromResponseObject = (raw)=>{
                const trimmed = raw.trim();
                if (!trimmed.startsWith('{')) return false;
                let payload;
                try {
                    payload = JSON.parse(trimmed);
                } catch (e) {
                    return false;
                }
                // Bare error envelope: {"error": {...}}
                if (payload.error && !payload.output) {
                    streamError = payload.error.message || payload.error;
                    return true;
                }
                if (!payload.output) return false;
                if (payload.model) servedModel = payload.model;
                payload.output.forEach(collectSources);
                fullContent = textFromOutput(payload.output);
                // Failed and cancelled runs arrive over HTTP 200 here too.
                if (payload.status === 'failed' || payload.status === 'cancelled') streamError = payload.error?.message || `Run ${payload.status}`;
                if (payload.incomplete_details?.reason === 'max_output_tokens') {
                    console.warn("\u26A0\uFE0F Answer truncated: max_output_tokens reached");
                    hitTokenCap = true;
                }
                return true;
            };
            while(true){
                const { done: done, value: value } = await reader.read();
                if (done) break;
                const chunk = decoder.decode(value, {
                    stream: true
                });
                rawBody += chunk;
                buffer += chunk;
                // Process complete lines ending with \n
                const lines = buffer.split('\n');
                buffer = lines.pop(); // Keep the incomplete line in buffer
                for (const line of lines)handleLine(line);
            }
            // Process any remaining data in buffer
            handleLine(buffer);
            // Nothing looked like an SSE event - fall back to the single-object shape.
            if (!matchedSSE) {
                const recovered = recoverFromResponseObject(rawBody);
                console.warn(recovered ? "\u26A0\uFE0F Response was not an event stream; recovered from a single JSON response object" : "\u26A0\uFE0F Unrecognised response body (first 500 chars): " + rawBody.slice(0, 500));
            }
            // Debug logging
            console.log("\uD83D\uDD0D Streaming complete. Content length:", fullContent.length);
            console.log("\uD83D\uDD0D Sources collected:", citations.length);
            console.log("\uD83D\uDD0D Terminal event seen:", sawTerminal);
            console.log("\uD83D\uDD0D Event types seen:", [
                ...eventFirstSeen
            ].map(([type, ms])=>`${type}@${ms}ms`).join(', ') || 'none');
            console.log("\uD83D\uDD0D Served model (what the preset resolved to):", servedModel || 'not reported');
            console.log("\uD83D\uDD0D Time to first answer token:", firstDeltaMs === null ? 'never arrived' : `${firstDeltaMs}ms`, `| total ${Date.now() - startedAt}ms`);
            // Failed and cancelled runs arrive over HTTP 200, so the terminal event
            // is the only signal that something went wrong.
            if (streamError) throw new Error(streamError);
            // No terminal event but text already streamed means the answer was cut
            // off mid-sentence - almost always the 30s function limit. Say so in the
            // answer itself: silently truncated prose reads as a complete answer and
            // is more misleading than an error would be.
            if (matchedSSE && !sawTerminal) {
                console.warn("\u26A0\uFE0F Stream ended without a terminal event - answer may be truncated");
                if (fullContent) fullContent += "\n\n_This answer was cut short before it finished. Try asking a narrower question._";
            }
            // Hitting the token cap ends the answer mid-sentence but still arrives as
            // a proper terminal event, so the cut-off check above does not catch it.
            // Say so rather than leaving a sentence hanging with no explanation.
            if (hitTokenCap && fullContent) fullContent += "\n\n_This answer reached its length limit and stops here. Ask a narrower question for a complete answer._";
            // Check if we got no content at all
            if (!fullContent) {
                console.warn("\u26A0\uFE0F No content received from API");
                fullContent = matchedSSE && !sawTerminal ? // searching - almost always the 30s serverless function limit.
                'The search timed out before an answer came back. Please try again, or ask a more specific question.' : 'No content was received from the API. This might be due to a configuration issue.';
            }
            const { content: content, relatedQuestions: relatedQuestions } = (0, $2d5ee9d6a3adacc4$export$28f17cdf29713751)(fullContent);
            return {
                content: content,
                citations: citations,
                related_questions: relatedQuestions
            };
        } catch (error) {
            console.error("\u274C API call failed:", error);
            if (error.name === 'AbortError') throw error;
            throw new Error('Failed to fetch answer: ' + error.message);
        }
    }
    // Helper function to escape HTML
    function escapeHtml(text) {
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        };
        return text.replace(/[&<>"']/g, (m)=>map[m]);
    }
    // formatStreamingChunk has been moved to formatStreamingChunk.js
    // formatResponse has been moved to formatResponse.js
    function displayResult(data) {
        const { content: content, relatedQuestions: relatedQuestions, citations: citations } = (0, $e4ca669c5b241a34$export$d8a9fb65f810e211)(data);
        console.log("\uD83D\uDCC4 Final formatted content preview:", content.substring(0, 500));
        console.log("\uD83D\uDCC4 Checking for unformatted headers:", content.match(/^###\s+/gm) ? 'FOUND UNFORMATTED HEADERS!' : 'No unformatted headers');
        // Display main content
        resultContainer.innerHTML = content;
        // Add citations
        if (citations && citations.length > 0) {
            let citationsHTML = '<div class="citations"><h3>Sources</h3><ol>';
            citations.forEach((citation, index)=>{
                citationsHTML += `<li id="citation-${index + 1}"><a href="${citation}" target="_blank" rel="noopener noreferrer">${citation}</a></li>`;
            });
            citationsHTML += '</ol></div>';
            resultContainer.innerHTML += citationsHTML;
        }
        // Image results were a Sonar-only feature (`return_images`). The Agent API
        // has no equivalent, so there is nothing to render here any more.
        imageContainer.innerHTML = '';
        // Render related questions
        if (relatedQuestions && relatedQuestions.length > 0) {
            console.log("\u2753 Displaying", relatedQuestions.length, 'related questions');
            let relatedHTML = '<div class="related-questions"><h3>Related Questions</h3><ul>';
            relatedQuestions.forEach((question)=>{
                relatedHTML += `<li><a href="#" class="related-question" data-question="${escapeHtml(question)}">${escapeHtml(question)}</a></li>`;
            });
            relatedHTML += '</ul></div>';
            resultContainer.innerHTML += relatedHTML;
        }
    }
    // Search button handler (with streaming)
    searchButton.addEventListener('click', async ()=>{
        let query = searchInput.value.trim();
        console.log("\uD83D\uDD0D Search clicked, query is:", query);
        query = (0, $29fac8d1b7d15aee$export$23ac54a073d6d184)(query);
        clearError();
        if (!query) return displayError('Please enter a query');
        // Predefined questions were answered at build time - render immediately
        // rather than spending ~28s regenerating the same answer.
        const precomputed = await getPrecomputedAnswer(query);
        if (precomputed) {
            console.log("\u26A1 Serving precomputed answer (no API call)");
            if (abortController) abortController.abort();
            displayResult(precomputed);
            history.push({
                role: 'user',
                content: query
            });
            history.push({
                role: 'assistant',
                content: precomputed.content || ''
            });
            return;
        }
        if (abortController) abortController.abort();
        abortController = new AbortController();
        // Prepare streaming container
        resultContainer.innerHTML = '<div class="loading-animation">Loading...</div><div id="streaming-result" class="streaming-result"></div>';
        const streamingEl = document.getElementById('streaming-result');
        const onChunk = (fullText)=>{
            // Apply progressive formatting to the streaming content
            const formattedChunk = (0, $5bde3d11ba71e4ca$export$7c68fd7983aa3ba2)(fullText);
            streamingEl.innerHTML = formattedChunk;
        };
        try {
            showLoadingTime(10);
            const data = await callPerplexityAPI(query, abortController.signal, onChunk);
            hideLoading();
            // After stream completes, render fully formatted content
            displayResult(data);
            // Update history for conversation context
            history.push({
                role: 'user',
                content: query
            });
            history.push({
                role: 'assistant',
                content: data.content || ''
            });
        } catch (error) {
            hideLoading();
            if (error.name !== 'AbortError') {
                console.error("\u274C Search error:", error);
                displayError(error.message);
            }
        } finally{
            hideLoadingTime();
        }
    });
    // Enter key handler
    searchInput.addEventListener('keydown', function(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            searchButton.click();
        }
    });
    // Related questions handler
    document.addEventListener('click', function(e) {
        const target = e.target.closest('a');
        if (target && target.classList.contains('related-question')) {
            e.preventDefault();
            const question = target.textContent.trim();
            console.log("\uD83D\uDD35 Related question clicked:", question);
            searchInput.value = question;
            scrollInputIntoView();
            searchButton.click();
        }
    });
    // Predefined questions handler
    document.addEventListener('click', function(e) {
        const target = e.target.closest('a');
        if (target && target.classList.contains('predefined-question')) {
            e.preventDefault();
            const question = target.textContent.trim();
            console.log("\uD83D\uDD35 Predefined question clicked:", question);
            searchInput.value = question;
            scrollInputIntoView();
            searchButton.click();
        }
    });
    // Fallback for table cells (if no links)
    document.querySelectorAll('table td').forEach((cell)=>{
        const text = cell.textContent.trim();
        if (text.endsWith('?') && !cell.querySelector('a')) {
            cell.style.cursor = 'pointer';
            cell.style.color = '#2980b9';
            cell.addEventListener('click', function() {
                console.log("\uD83D\uDD35 Table question clicked:", text);
                searchInput.value = text;
                scrollInputIntoView();
                searchButton.click();
            });
        }
    });
    // Summary buttons (optional streaming)
    document.getElementById('short-summary')?.addEventListener('click', ()=>handleSummary(50));
    document.getElementById('medium-summary')?.addEventListener('click', ()=>handleSummary(150));
    document.getElementById('long-summary')?.addEventListener('click', ()=>handleSummary(300));
    async function handleSummary(wordCount) {
        const prompt = `Summarize the Telia Ericsson NorthStar 5G innovation network in ${wordCount} words. Focus on technical aspects.`;
        if (summaryAbortController) summaryAbortController.abort();
        summaryAbortController = new AbortController();
        clearError();
        try {
            const summaryContent = document.getElementById('summary-content');
            if (summaryContent) {
                summaryContent.innerHTML = '<div class="loading-animation">Loading...</div><div id="summary-stream" class="streaming-result"></div>';
                const summaryStreamEl = document.getElementById('summary-stream');
                const stripRefs = (text)=>text.replace(/\[\d+\]/g, '');
                const onChunk = (fullText)=>{
                    // Apply progressive formatting to the summary streaming content
                    const formattedChunk = (0, $5bde3d11ba71e4ca$export$7c68fd7983aa3ba2)(stripRefs(fullText));
                    summaryStreamEl.innerHTML = formattedChunk;
                };
                const data = await callPerplexityAPI(prompt, summaryAbortController.signal, onChunk);
                // Strip citation references and don't pass citations to formatResponse
                data.content = stripRefs(data.content || '');
                data.citations = [];
                const formatted = (0, $e4ca669c5b241a34$export$d8a9fb65f810e211)(data);
                summaryContent.innerHTML = formatted.content || 'No summary available';
            }
        } catch (error) {
            if (error.name !== 'AbortError') displayError(error.message);
        }
    }
});


//# sourceMappingURL=repo.b084bc2f.js.map
